import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StopsStationsInterface } from '@app/components/map/map.component';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BusInterface } from '../models/bus.model';
import { Geometry, ShapesInterface } from '../models/shapes.model';
import { RouteInterface, StopsInterface } from '../models/stops.model';

@Injectable({
  providedIn: 'root',
})
export class BusService {
  baseUrl = `${environment.apiUrl}`;
  simulateUrl = `${environment.apiUrlSimulate}`;
  simulatePath = 'simulate';
  siriUrl = `${environment.apiSiriUrl}`;

  constructor(private http: HttpClient, private router: Router) {}

  getBusList(): Observable<BusInterface[]> {
    if (this.router.url.includes(this.simulatePath)) {
      return this.http
        .get<BusInterface[]>(`${this.simulateUrl}/routes`, {})
        .pipe(map((res) => res));
    } else {
      console.log('LLamada routes ---- Con headers');
      return this.http
        .get<BusInterface[]>(`${this.baseUrl}/routes`, {
          headers: new HttpHeaders({
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            Pragma: 'no-cache',
            Expires: '0',
          }),
        })
        .pipe(map((res) => res));
    }
  }

  getStopsList(busId: number, direction: number): Observable<StopsInterface> {
    console.log('getStopsList', busId, direction);
    if (this.router.url.includes(this.simulatePath)) {
      return this.http
        .get<StopsInterface>(`${this.simulateUrl}/route/${busId}/stops?direction=${direction}`, {})
        .pipe(map((res) => res));
    } else {
      return this.http
        .get<StopsInterface>(`${this.baseUrl}/route/${busId}/stops?direction=${direction}`, {})
        .pipe(map((res) => res));
    }
  }

  getShapesList(busId: number): Observable<ShapesInterface> {
    if (this.router.url.includes(this.simulatePath)) {
      return this.http
        .get<ShapesInterface>(`${this.simulateUrl}/route/${busId}/shapes`, {})
        .pipe(map((res) => res));
    } else {
      return this.http
        .get<ShapesInterface>(`${this.baseUrl}/route/${busId}/shapes`, {})
        .pipe(map((res) => res));
    }
  }

  getTimesList(stopId: number, direction: number, busStopsUrl?: string): Observable<any> {
    if (this.router.url.includes(this.simulatePath)) {
      return this.http
        .get<any>(
          `${this.simulateUrl}/stop/${stopId}/times?direction_id=${direction}${busStopsUrl}`,
          {}
        )
        .pipe(map((res) => res));
    } else {
      return this.http
        .get<any>(
          `${this.baseUrl}/stop/${stopId}/times?direction_id=${direction}${busStopsUrl}`,
          {}
        )
        .pipe(map((res) => res));
    }
  }

  getTimesListWithDate(
    stopId: number,
    direction: number,
    busStopsUrl?: string,
    date?: string
  ): Observable<any> {
    if (this.router.url.includes(this.simulatePath)) {
      return this.http
        .get<any>(
          `${this.simulateUrl}/stop/${stopId}/times?direction_id=${direction}` +
            `${busStopsUrl}&date=${date}`,
          {}
        )
        .pipe(map((res) => res));
    } else {
      return this.http
        .get<any>(
          `${this.baseUrl}/stop/${stopId}/times?direction_id=${direction}` +
            `${busStopsUrl}&date=${date}`,
          {}
        )
        .pipe(map((res) => res));
    }
  }

  getListOfRoutes(stopId: number): Observable<RouteInterface[]> {
    console.log('getListOfRoutes');
    if (this.router.url.includes(this.simulatePath)) {
      return this.http
        .get<RouteInterface[]>(`${this.simulateUrl}/stop/${stopId}/routes`, {})
        .pipe(map((res) => res));
    } else {
      return this.http
        .get<RouteInterface[]>(`${this.baseUrl}/stop/${stopId}/routes`, {})
        .pipe(map((res) => res));
    }
  }

  // DEV-2162 rafa@softoursistemas.com
  getListOfEstimates(stopId: string): Observable<any[]> {
    console.log('getListOfEstimates');
    return this.http
      .get<any[]>(`${this.baseUrl}/stop/${stopId}/estimation`, {})
      .pipe(map((res) => res));
  }

  getListOfAllStops(): Observable<StopsStationsInterface[]> {
    if (
      this.router.url.includes(this.simulatePath) ||
      window.location.href.includes(this.simulatePath)
    ) {
      return this.http
        .get<StopsStationsInterface[]>(`${this.simulateUrl}/stops`, {})
        .pipe(map((res) => res));
    } else {
      return this.http
        .get<StopsStationsInterface[]>(`${this.baseUrl}/stops`, {})
        .pipe(map((res) => res));
    }
  }

  getSiriTimesList(stopId: number, busStopsUrl?: string): Observable<Geometry> {
    return this.http
      .get<any>(`${this.siriUrl}/stop/${stopId}/today?${busStopsUrl}`, {})
      .pipe(map((res) => res));
  }
}
